<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="inertia-link"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: null,
                    },
                    {
                        name: $tc('messages.rubrics', 1),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex space-x-2 items-center">
            <img
                :src="student.avatar_or_default"
                :alt="student.full_name"
                :title="student.full_name"
                class="rounded-full h-10"
            />
            <div>{{ student.full_name }}</div>
        </div>

        <div>
            <AlertMessage class="mt-5 inline-block" type="info">
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <template v-slot:body> {{ $t('messages.rubric_self_grading_explanation_for_students') }} </template>
            </AlertMessage>
        </div>

        <div v-if="activity.materials.length > 0" class="mt-3 md:mt-5">
            <div>
                {{ $tc('messages.materials', 2) }}
            </div>
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-12">
                    <ul class="">
                        <li v-for="(row, index) in activity.materials" :key="index" class="list-disc">
                            <span v-if="!row.url">
                                {{ row.title }}
                            </span>
                            <a :href="row.url" target="_blank" class="text-indigo-500" v-else>
                                <svg
                                    class="w-4 h-4 inline-block"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                                    ></path>
                                    <path
                                        d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                                    ></path>
                                </svg>
                                <span class="truncate text-ellipsis overflow-hidden">
                                    {{ row.title ? row.title : row.url }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <RubricGrade v-model="form.rubric" :ranges="ranges" />

            <div class="flex justify-end mt-5">
                <div>
                    <AppButton desired-action element="button" type="submit" @click="save()">
                        {{ $t('messages.save') }}
                        <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                    </AppButton>
                </div>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import GradeTranslator from '@/classes/GradeTranslator.js';
import RubricGrade from '@/Pages/Teacher/Activities/Rubrics/RubricGrade.vue';
import AlertMessage from '@/components/AlertMessage.vue';

export default {
    components: {
        RubricGrade,
        PanelPage,
        AppButton,
        AlertMessage,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'student', 'activity', 'ranges'],
    data() {
        return {
            gradeTranslator: new GradeTranslator(this.ranges),
            form: this.$inertia.form({
                student_id: this.student.id,
                rubric: JSON.parse(JSON.stringify(this.activity.rubric)),
            }),
        };
    },
    methods: {
        save() {
            this.form.redirect_url = this.meta.links.rubric_show;
        },
        submit() {
            this.form.patch(this.meta.links.update, {
                preserveState: false,
            });
        },
    },
};
</script>
